import { SELECTION_KEY } from '@techchange/pm-specs';

/**
 * Marks the nodes contained within the current selection in order
 * to keep track of the originally selected nodes after changes to the document.
 *
 * @param {Object} state     The current editor state.
 * @param {Object} tr        The current transaction instance.
 */
const markSelection = (state, tr) => {

	const { schema, selection: { from, to } } = state;

	// Add mark to selected inline nodes to remember original selection
	if (from === to) {

		// Insert placeholder with selection mark for cursor selections
		const selectionPlaceholder = schema.text('placeholder', schema.mark(SELECTION_KEY));

		tr.insert(from, selectionPlaceholder);

	} else {

		tr.addMark(from, to, schema.mark(SELECTION_KEY));

	}

};

export default markSelection;
